import { REHYDRATE } from 'redux-persist/src/constants';

import YouthAthlete from 'models/YouthAthlete';
import Base from 'models/Base';

import {
  YOUTHATHLETE_ASYNC_START,
  YOUTHATHLETE_ASYNC_FAIL,
  YOUTHATHLETE_ASYNC_SUCCESS,
  YOUTHATHLETE_ASYNC_CLEAR_ERROR,
} from 'actions/youthAthlete';

const initialState = new Base({
  loading: false,
  errorMessage: '',
  data: new YouthAthlete(),
  currentYouthAthleteId: null,
});

const actionsMap = {
  [YOUTHATHLETE_ASYNC_CLEAR_ERROR]: (state) => {
    return state.merge({
      loading: false,
      errorMessage: '',
    });
  },
  [YOUTHATHLETE_ASYNC_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: '',
    });
  },
  [YOUTHATHLETE_ASYNC_FAIL]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.errorMessage,
    });
  },
  [YOUTHATHLETE_ASYNC_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: new YouthAthlete(action.data),
    });
  },
  [REHYDRATE]: (state, action) => {
    const payload = action.payload;
    const currentYouthAthlete = payload ? payload.youthAthlete : null;

    if (currentYouthAthlete) {
      return new Base({
        loading: false,
        errorMessage: '',
        data: new YouthAthlete(currentYouthAthlete.data),
      });
    }
    return new Base({
      loading: false,
      errorMessage: '',
      data: new YouthAthlete(),
      currentYouthAthleteId: null,
    });
  },
};

export default function youthAthlete(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
